// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"FD-z","smallCardRow":"GD-z","largeCardRow":"HD-z","productSearchRow":"ID-z","curatedRow":"JD-z"};